const PDF_SERIAL_FORMAT_TYPE_CODE = "4";

export const shouldUsePdfSerial = (
  formatTypeCode: string | null,
  checkPdfSerialOnNullFormat: boolean,
) => {
  if (formatTypeCode === PDF_SERIAL_FORMAT_TYPE_CODE) {
    return true;
  }

  return !formatTypeCode && checkPdfSerialOnNullFormat;
};
